import React, { Fragment } from "react";
import {useQueryClient} from "react-query";
import {useBookingsTrips} from "../../../../services/booking";


const TripConnection = (props) => {
  const {bookingUuid} = props;

  const queryClient = useQueryClient();
  const extraKeys = [bookingUuid];
  const trips = useBookingsTrips({queryClient, extraKeys});

  let tripInfo = [];
  let index = 1;
  if (trips && trips.data && Array.isArray(trips.data) && trips.data.length > 0) {
    if (trips.data.length > 1) {
      trips.data.forEach(trip => {
        tripInfo.push(`${trip.tripPrefix}${trip.tripNo}`);
        if (index < trips.data.length) {
          tripInfo.push(`connecting with`);
          index++;
        }
      });
    } else {
      tripInfo.push(trips.data[0].tripRoute);
    }
  }

  return (
    <Fragment>
      {trips.data
        ?
          <span>{tripInfo.join(" ")}</span>
        :
          <></>
      }
    </Fragment>
  );
}

export default TripConnection;
